// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;

function makeInitialState(param) {
  return {
          expr1Str: "",
          expr1Err: undefined,
          expr2Str: "",
          expr2Err: undefined,
          results: undefined,
          checkedResultIdx: -1
        };
}

function setResults(st, results) {
  return {
          expr1Str: st.expr1Str,
          expr1Err: st.expr1Err,
          expr2Str: st.expr2Str,
          expr2Err: st.expr2Err,
          results: results,
          checkedResultIdx: results.length === 1 ? 0 : -1
        };
}

function setExpr1Str(st, str) {
  return {
          expr1Str: str,
          expr1Err: st.expr1Err,
          expr2Str: st.expr2Str,
          expr2Err: st.expr2Err,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx
        };
}

function setExpr2Str(st, str) {
  return {
          expr1Str: st.expr1Str,
          expr1Err: st.expr1Err,
          expr2Str: str,
          expr2Err: st.expr2Err,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx
        };
}

function toggleResultChecked(st, idx) {
  if (st.checkedResultIdx === idx) {
    return {
            expr1Str: st.expr1Str,
            expr1Err: st.expr1Err,
            expr2Str: st.expr2Str,
            expr2Err: st.expr2Err,
            results: st.results,
            checkedResultIdx: -1
          };
  } else {
    return {
            expr1Str: st.expr1Str,
            expr1Err: st.expr1Err,
            expr2Str: st.expr2Str,
            expr2Err: st.expr2Err,
            results: st.results,
            checkedResultIdx: idx
          };
  }
}

function MM_cmp_substitution(Props) {
  var editorState = Props.editorState;
  var wrkCtx = Props.wrkCtx;
  var onCanceled = Props.onCanceled;
  var onSubstitutionSelected = Props.onSubstitutionSelected;
  var match = React.useState(function () {
        return {
                expr1Str: "",
                expr1Err: undefined,
                expr2Str: "",
                expr2Err: undefined,
                results: undefined,
                checkedResultIdx: -1
              };
      });
  var setState = match[1];
  var state = match[0];
  var actExpr1Change = function (str) {
    Curry._1(setState, (function (__x) {
            return setExpr1Str(__x, str);
          }));
  };
  var actExpr2Change = function (str) {
    Curry._1(setState, (function (__x) {
            return setExpr2Str(__x, str);
          }));
  };
  var rndError = function (msgOpt) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndExpr = function (label, value, autoFocus, onChange) {
    return React.createElement(TextField, {
                value: value,
                label: label,
                size: "small",
                style: {
                  width: "300px"
                },
                onChange: (function (param) {
                    return Expln_React_common.evt2str(onChange, param);
                  }),
                autoFocus: autoFocus
              });
  };
  var rndInput = function (param) {
    return React.createElement(Expln_React_Column.make, {
                children: null
              }, rndExpr("Replace what", state.expr1Str, true, actExpr1Change), rndError(state.expr1Err), rndExpr("Replace with", state.expr2Str, false, actExpr2Change), rndError(state.expr2Err), React.createElement(Expln_React_Row.make, {
                    children: null
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            var findIncorrectSymbol = function (syms) {
                              return Caml_option.undefined_to_opt(syms.find(function (sym) {
                                              return !(MM_context.isConst(wrkCtx, sym) || MM_context.isVar(wrkCtx, sym));
                                            }));
                            };
                            var syms1 = MM_parser.getSpaceSeparatedValuesAsArray(state.expr1Str);
                            var incorrectSymbol1 = findIncorrectSymbol(syms1);
                            var syms2 = MM_parser.getSpaceSeparatedValuesAsArray(state.expr2Str);
                            var incorrectSymbol2 = findIncorrectSymbol(syms2);
                            Curry._1(setState, (function (st) {
                                    var st$1 = incorrectSymbol1 !== undefined ? ({
                                          expr1Str: st.expr1Str,
                                          expr1Err: "Unknown symbol - '" + incorrectSymbol1 + "'",
                                          expr2Str: st.expr2Str,
                                          expr2Err: st.expr2Err,
                                          results: st.results,
                                          checkedResultIdx: st.checkedResultIdx
                                        }) : ({
                                          expr1Str: st.expr1Str,
                                          expr1Err: undefined,
                                          expr2Str: st.expr2Str,
                                          expr2Err: st.expr2Err,
                                          results: st.results,
                                          checkedResultIdx: st.checkedResultIdx
                                        });
                                    if (incorrectSymbol2 !== undefined) {
                                      return {
                                              expr1Str: st$1.expr1Str,
                                              expr1Err: st$1.expr1Err,
                                              expr2Str: st$1.expr2Str,
                                              expr2Err: "Unknown symbol - '" + incorrectSymbol2 + "'",
                                              results: st$1.results,
                                              checkedResultIdx: st$1.checkedResultIdx
                                            };
                                    } else {
                                      return {
                                              expr1Str: st$1.expr1Str,
                                              expr1Err: st$1.expr1Err,
                                              expr2Str: st$1.expr2Str,
                                              expr2Err: undefined,
                                              results: st$1.results,
                                              checkedResultIdx: st$1.checkedResultIdx
                                            };
                                    }
                                  }));
                            if (!(Belt_Option.isNone(incorrectSymbol1) && Belt_Option.isNone(incorrectSymbol2))) {
                              return ;
                            }
                            var results = MM_wrk_editor.findPossibleSubs(editorState, MM_context.ctxSymsToIntsExn(wrkCtx, syms1), MM_context.ctxSymsToIntsExn(wrkCtx, syms2));
                            Curry._1(setState, (function (__x) {
                                    return setResults(__x, results);
                                  }));
                          }),
                        variant: "contained",
                        children: "Extract substitution"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onCanceled, undefined);
                          }),
                        children: "Cancel"
                      })));
  };
  var rndResultButtons = function (param) {
    var results = state.results;
    var onlyOneSubstitutionIsAvailable = results !== undefined ? results.length === 1 : false;
    return React.createElement(Expln_React_Row.make, {
                children: null
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        var results = state.results;
                        if (results !== undefined && 0 <= state.checkedResultIdx && state.checkedResultIdx < results.length) {
                          return Curry._1(onSubstitutionSelected, Caml_array.get(results, state.checkedResultIdx));
                        }
                        
                      }),
                    variant: "contained",
                    disabled: state.checkedResultIdx < 0,
                    children: onlyOneSubstitutionIsAvailable ? "Apply substitution" : "Apply selected"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onCanceled, undefined);
                      }),
                    children: "Cancel"
                  }));
  };
  var rndWrkSubs = function (subs) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, Belt_MapInt.toArray(subs).map(function (param) {
                        var expr = param[1];
                        var v = param[0];
                        if (expr.length === 1 && v === Caml_array.get(expr, 0)) {
                          return null;
                        } else {
                          return React.createElement("tr", {
                                      key: String(v)
                                    }, React.createElement("td", undefined, MM_context.ctxIntToSymExn(wrkCtx, v)), React.createElement("td", undefined, "\u2192"), React.createElement("td", undefined, MM_context.ctxIntsToStrExn(wrkCtx, expr)));
                        }
                      })));
  };
  var rndResults = function (param) {
    var results = state.results;
    if (results === undefined) {
      return null;
    }
    var numOfResults = results.length;
    if (numOfResults === 0) {
      return React.createElement("span", undefined, "No substitution can be extracted from the provided expressions.");
    } else {
      return React.createElement(Expln_React_Column.make, {
                  children: null
                }, results.map(function (res, i) {
                      return React.createElement("table", {
                                  key: String(i)
                                }, React.createElement("tbody", undefined, React.createElement("tr", undefined, numOfResults > 1 ? React.createElement("td", undefined, React.createElement(Checkbox, {
                                                    checked: state.checkedResultIdx === i,
                                                    onChange: (function (param) {
                                                        Curry._1(setState, (function (__x) {
                                                                return toggleResultChecked(__x, i);
                                                              }));
                                                      })
                                                  })) : null, React.createElement("td", undefined, rndWrkSubs(res)))));
                    }), rndResultButtons(undefined));
    }
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    spacing: 1,
                    children: null
                  }, rndInput(undefined), rndResults(undefined))
            });
}

var make = MM_cmp_substitution;

exports.makeInitialState = makeInitialState;
exports.setResults = setResults;
exports.setExpr1Str = setExpr1Str;
exports.setExpr2Str = setExpr2Str;
exports.toggleResultChecked = toggleResultChecked;
exports.make = make;
/* react Not a pure module */
